/* library-lp99.js (HOME-99, D99 and D108, 22 Oct 2026): the perpetual shelves of the home. ONE file for the shop theme and the design page (design/build.py inlines it).
   [data-lp99]        a shelf (.strip): drifts while it is on screen and not held, smooth in every frame (browsers round scrollLeft to whole pixels, so the sub-pixel rest goes into a
                      transform of the shelf). Shelves alternate by their place on the page: the 1st, 3rd, 5th ... drift toward their end, the 2nd, 4th ... toward their start (only once
                      their list is complete; until then they drift toward the end too), at 24, 18, 21 and 15 px/s in turn (0.7 times that below 900 px). Once a list is complete its first
                      books follow its end card as copies (aria-hidden, out of the tab order, inert while it drifts), so the loop has no jump. Complete = the shelf loader set data-lp99-done,
                      or the last book is the end card, or the shelf has neither data-more-url nor data-shelf. Mouse over, touch, wheel, focus inside and the row's arrow buttons only hold it;
                      an arrow click, a swipe or drag of more than 30 px or a sideways wheel stops that shelf for the rest of the visit (attribute data-lp99-stopped).
   [data-lp99-cards]  the formats cards on phones: one card every 4.5 s, the same holds.
   [data-lp99-mq]     the two cover rows of the hero (a CSS animation): the script only holds them (class lp99-held pauses the animation).
   Nothing moves under prefers-reduced-motion, in a hidden tab or off screen. Frozen tests: website/tools/sol-build/tasks/home99-lp99b (written by gpt-6.1-sol against them). */
(function () {
  'use strict';

  if (window.lp99) {
    return;
  }
  window.lp99 = { version: 1 };
  if (!window.IntersectionObserver) {
    return;
  }

  var targets = [];
  var pending = null;
  var previous = null;
  var reduceQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  var desktopQuery = window.matchMedia('(min-width: 900px)');
  var phoneQuery = window.matchMedia('(max-width: 759px)');

  function reduced() {
    return reduceQuery.matches;
  }

  function attribute(el, name, on) {
    if (on && !el.hasAttribute(name)) {
      el.setAttribute(name, '');
    } else if (!on && el.hasAttribute(name)) {
      el.removeAttribute(name);
    }
  }

  function rest(s) {
    if (!s.cards && !s.hero && s.el.style.transform) {
      s.el.style.transform = '';
    }
  }

  function copies(s) {
    var out = [];
    var children = s.el.children;
    var i;
    for (i = 0; i < children.length; i++) {
      if (children[i].hasAttribute('data-lp99-copy')) {
        out.push(children[i]);
      }
    }
    return out;
  }

  function held(s, now) {
    return s.hover || s.focus || s.touching || now < s.resumeAt || s.stopped;
  }

  function markHold(s, now) {
    var on = !reduced() && held(s, now);
    var list = copies(s);
    var i;
    if (s.el.classList.contains('lp99-held') !== !!on) {
      if (on) {
        s.el.classList.add('lp99-held');
      } else {
        s.el.classList.remove('lp99-held');
      }
    }
    for (i = 0; i < list.length; i++) {
      attribute(list[i], 'inert', !on);
    }
    if (on) {
      rest(s);
      s.timer = 0;
    }
  }

  function stop(s, now) {
    if (!s.cards && !s.hero && !s.stopped) {
      s.stopped = true;
      attribute(s.el, 'data-lp99-stopped', true);
      markHold(s, now);
    }
  }

  function gesture(s, amount, now) {
    if (s.cards || s.hero || amount <= 0 || s.stopped) {
      return;
    }
    if (now - s.gestureAt > 250) {
      s.sum = 0;
    }
    s.sum += amount;
    s.gestureAt = now;
    if (s.sum > 30) {
      stop(s, now);
    }
  }

  function delay(s, now, ms) {
    s.resumeAt = Math.max(s.resumeAt, now + ms);
  }

  function bind(s) {
    var el = s.el;
    var row;
    var buttons;
    var i;
    function event(e) {
      var now = window.performance.now();
      var x;
      var y;
      if (e.type === 'pointerenter' || e.type === 'pointerleave') {
        if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') {
          return;
        }
        s.hover = e.type === 'pointerenter';
        if (!s.hover) {
          delay(s, now, 600);
        }
      } else if (e.type === 'touchstart') {
        s.touching = true;
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        s.touching = false;
        delay(s, now, 3000);
      } else if (e.type === 'focusin') {
        s.focus = true;
      } else if (e.type === 'focusout') {
        if (!el.contains(e.relatedTarget)) {
          s.focus = false;
          delay(s, now, 600);
        }
      } else {
        delay(s, now, 3000);
        if (e.type === 'click') {
          stop(s, now);
        } else if (e.type === 'wheel') {
          x = Math.abs(e.deltaX || 0);
          y = Math.abs(e.deltaY || 0);
          gesture(s, e.shiftKey ? x + y : (x > y ? x : 0), now);
        }
      }
      markHold(s, now);
    }
    var events = [
      'pointerenter', 'pointerleave', 'touchstart', 'touchend',
      'touchcancel', 'wheel', 'focusin', 'focusout'
    ];
    for (i = 0; i < events.length; i++) {
      if (events[i] === 'touchstart' || events[i] === 'touchend' ||
          events[i] === 'touchcancel' || events[i] === 'wheel') {
        el.addEventListener(events[i], event, { passive: true });
      } else {
        el.addEventListener(events[i], event);
      }
    }
    if (!s.cards && !s.hero) {
      row = el.closest('.row');
      if (row) {
        buttons = row.querySelectorAll('.arrows button');
        for (i = 0; i < buttons.length; i++) {
          buttons[i].addEventListener('pointerdown', event);
          buttons[i].addEventListener('click', event);
          buttons[i].addEventListener('keydown', event);
        }
      }
    }
  }

  function clear(s) {
    var list = copies(s);
    var i;
    rest(s);
    for (i = 0; i < list.length; i++) {
      s.el.removeChild(list[i]);
    }
    attribute(s.el, 'data-lp99-on', false);
    if (s.el.classList.contains('lp99-held')) {
      s.el.classList.remove('lp99-held');
    }
    s.timer = 0;
    s.width = null;
    s.backward = false;
    if (!s.hero) {
      s.pos = Math.abs(s.el.scrollLeft);
      s.made = s.pos;
    }
  }

  function span(first, last) {
    var a = first.getBoundingClientRect();
    var b = last.getBoundingClientRect();
    return Math.max(a.right, b.right) - Math.min(a.left, b.left);
  }

  function distance(a, b) {
    return Math.abs(a.getBoundingClientRect().left -
      b.getBoundingClientRect().left);
  }

  function fill(s, originals, list, pitch) {
    var el = s.el;
    var copy;
    var inner;
    var i;
    while (list.length < 300 &&
        (!list.length ||
        span(list[0], list[list.length - 1]) < el.clientWidth + pitch)) {
      copy = originals[list.length % originals.length].cloneNode(true);
      copy.setAttribute('data-lp99-copy', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('tabindex', '-1');
      inner = copy.querySelectorAll('a, button, input, select, textarea, [tabindex]');
      for (i = 0; i < inner.length; i++) {
        inner[i].setAttribute('tabindex', '-1');
      }
      el.appendChild(copy);
      list.push(copy);
    }
    s.width = el.clientWidth;
  }

  function read(s, now) {
    var actual = Math.abs(s.el.scrollLeft);
    var change = Math.abs(actual - (s.made === null ? 0 : s.made));
    if (now < s.ignoreUntil) {
      s.made = actual;
    } else {
      if (s.made !== null && change > 0.5) {
        gesture(s, change, now);
      }
      if (change > 1.5) {
        delay(s, now, 3000);
        s.outside = now;
        s.pos = actual;
        s.made = actual;
      } else if (change > 0.5 || s.made === null) {
        s.pos = actual;
        s.made = actual;
      }
    }
    if (held(s, now)) {
      s.pos = actual;
      s.made = actual;
    }
  }

  function write(s, direction, drifting) {
    var whole = Math.floor(s.pos);
    var fraction;
    s.el.scrollLeft = direction * whole;
    s.made = Math.abs(s.el.scrollLeft);
    if (drifting) {
      fraction = Math.round(-direction * (s.pos - whole) * 1000) / 1000;
      s.el.style.transform = 'translateX(' + fraction + 'px)';
    }
  }

  function shelf(s, now, dt, speed) {
    var el = s.el;
    var originals = [];
    var list = [];
    var i;
    var child;
    var pitch;
    var complete;
    var loop = 0;
    var holding;
    var backward;
    var max;
    var direction = window.getComputedStyle(el).direction === 'rtl' ? -1 : 1;
    for (i = 0; i < el.children.length; i++) {
      child = el.children[i];
      if (child.hasAttribute('data-lp99-copy')) {
        list.push(child);
      } else {
        originals.push(child);
      }
    }
    if (!originals.length || el.clientWidth <= 0 ||
        span(originals[0], originals[originals.length - 1]) <= el.clientWidth + 1) {
      clear(s);
      return;
    }
    attribute(el, 'data-lp99-on', true);
    pitch = originals.length > 1 ? distance(originals[0], originals[1]) :
      originals[0].getBoundingClientRect().width;
    complete = list.length > 0 || el.hasAttribute('data-lp99-done') ||
      originals[originals.length - 1].classList.contains('end') ||
      (!el.hasAttribute('data-more-url') && !el.hasAttribute('data-shelf'));
    if (complete && (!list.length || s.width !== el.clientWidth)) {
      fill(s, originals, list, pitch);
    }
    if (list.length) {
      loop = distance(originals[0], list[0]);
    }
    max = Math.max(0, el.scrollWidth - el.clientWidth);
    backward = s.order % 2 === 1 && loop > 0;
    read(s, now);
    holding = held(s, now);
    markHold(s, now);
    if (!holding) {
      if (backward) {
        if (!s.backward) {
          if (s.pos + loop <= max) {
            s.pos += loop;
          }
          s.backward = true;
        }
        s.pos -= speed * dt;
        if (s.pos < 0) {
          s.pos += loop;
        }
      } else {
        s.pos += speed * dt;
        if (loop > 0 && s.pos >= loop) {
          s.pos %= loop;
        }
      }
      s.pos = Math.max(0, Math.min(s.pos, max));
      write(s, direction, true);
    } else if (loop > 0 && s.pos >= loop &&
        !s.touching && now - s.outside >= 200) {
      s.pos %= loop;
      write(s, direction, false);
    }
  }

  function cards(s, now, dt) {
    var el = s.el;
    var pitch;
    var index;
    var target;
    var actual;
    var direction;
    if (!phoneQuery.matches ||
        el.clientWidth <= 0 || el.scrollWidth <= el.clientWidth + 1 ||
        el.children.length < 2) {
      s.timer = 0;
      markHold(s, now);
      return;
    }
    read(s, now);
    markHold(s, now);
    if (held(s, now)) {
      s.timer = 0;
      return;
    }
    s.timer += dt * 1000;
    if (s.timer < 4500) {
      return;
    }
    s.timer = 0;
    pitch = distance(el.children[0], el.children[1]);
    if (pitch <= 0) {
      return;
    }
    actual = Math.abs(el.scrollLeft);
    index = Math.round(actual / pitch);
    target = (index + 1) * pitch;
    if (index >= el.children.length - 1 ||
        actual >= el.scrollWidth - el.clientWidth - 2) {
      target = 0;
    }
    direction = window.getComputedStyle(el).direction === 'rtl' ? -1 : 1;
    s.ignoreUntil = now + 1500;
    el.scrollTo({ left: direction * target, behavior: 'smooth' });
    s.made = Math.abs(el.scrollLeft);
  }

  function running() {
    var i;
    if (document.hidden) {
      return false;
    }
    for (i = 0; i < targets.length; i++) {
      if (targets[i].visible) {
        return true;
      }
    }
    return false;
  }

  function schedule() {
    if (running()) {
      if (pending === null) {
        previous = null;
        pending = window.requestAnimationFrame(frame);
      }
    } else {
      if (pending !== null) {
        window.cancelAnimationFrame(pending);
        pending = null;
      }
      previous = null;
    }
  }

  function frame(now) {
    var dt = previous === null ? 0 :
      Math.max(0, Math.min(0.1, (now - previous) / 1000));
    var reduce = reduced();
    var scale = desktopQuery.matches ? 1 : 0.7;
    var i;
    var s;
    pending = null;
    previous = now;
    for (i = 0; i < targets.length; i++) {
      s = targets[i];
      if (!s.visible) {
        continue;
      }
      if (reduce) {
        clear(s);
      } else if (s.hero) {
        markHold(s, now);
      } else if (s.cards) {
        cards(s, now, dt);
      } else {
        shelf(s, now, dt, [24, 18, 21, 15][s.order % 4] * scale);
      }
    }
    if (running()) {
      pending = window.requestAnimationFrame(frame);
    } else {
      previous = null;
    }
  }

  function start() {
    var observer = new window.IntersectionObserver(function (entries) {
      var i;
      var j;
      for (i = 0; i < entries.length; i++) {
        for (j = 0; j < targets.length; j++) {
          if (targets[j].el === entries[i].target) {
            targets[j].visible = !!entries[i].isIntersecting;
            if (!targets[j].visible) {
              rest(targets[j]);
            }
          }
        }
      }
      schedule();
    });
    function add(selector, isCards, isHero) {
      var elements = document.querySelectorAll(selector);
      var i;
      var s;
      for (i = 0; i < elements.length; i++) {
        s = {
          el: elements[i],
          cards: isCards,
          hero: isHero,
          order: i,
          backward: false,
          stopped: false,
          sum: 0,
          gestureAt: -Infinity,
          visible: false,
          hover: false,
          focus: false,
          touching: false,
          resumeAt: 0,
          outside: -Infinity,
          ignoreUntil: 0,
          pos: 0,
          made: null,
          timer: 0,
          width: null
        };
        targets.push(s);
        bind(s);
        observer.observe(s.el);
      }
    }
    add('[data-lp99]', false, false);
    add('[data-lp99-cards]', true, false);
    add('[data-lp99-mq]', false, true);
    document.addEventListener('visibilitychange', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
